import { Buffer } from 'buffer'
import process from 'process'

const global = globalThis

// Some browser dependencies read these through globalThis rather than lexical identifiers.
const browserGlobals = globalThis as typeof globalThis & {
  Buffer?: typeof Buffer
  global?: typeof globalThis
  process?: typeof process
}
browserGlobals.Buffer ??= Buffer
browserGlobals.process ??= process
browserGlobals.global ??= global

export { Buffer, global, process }
